const scriptRel = 'modulepreload',
  assetsURL = function (dep) {
    return '/' + dep;
  },
  seen = {},
  __vitePreload = function (baseModule, deps, importerUrl) {
    if (!deps || deps.length === 0) return baseModule();
    const links = document.getElementsByTagName('link');
    return Promise.all(
      deps.map((dep) => {
        if (((dep = assetsURL(dep)), dep in seen)) return;
        seen[dep] = !0;
        const isCss = dep.endsWith('.css'),
          cssSelector = isCss ? '[rel="stylesheet"]' : '';
        if (!!importerUrl)
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === 'stylesheet')) return;
          }
        else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) return;
        const link = document.createElement('link');
        if (
          ((link.rel = isCss ? 'stylesheet' : scriptRel),
          isCss || ((link.as = 'script'), (link.crossOrigin = '')),
          (link.href = dep),
          document.head.appendChild(link),
          isCss)
        )
          return new Promise((res, rej) => {
            link.addEventListener('load', res),
              link.addEventListener('error', () => rej(new Error(`Unable to preload CSS for ${dep}`)));
          });
      })
    ).then(() => baseModule());
  };
function fetchConfig(type = 'json') {
  return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/${type}` } };
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t), (t = setTimeout(() => fn.apply(this, args), wait));
  };
}
const trapFocusHandlers = {};
function trapFocus$1(container, elementToFocus = container) {
  var elements = getFocusableElements(container),
    first = elements[0],
    last = elements[elements.length - 1];
  removeTrapFocus$1(),
    (trapFocusHandlers.focusin = (event) => {
      (event.target !== container && event.target !== last && event.target !== first) ||
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    }),
    (trapFocusHandlers.keydown = function (event) {
      event.code.toUpperCase() === 'TAB' &&
        (event.target === last && !event.shiftKey && (event.preventDefault(), first.focus()),
        (event.target === container || event.target === first) &&
          event.shiftKey &&
          (event.preventDefault(), last.focus()));
    }),
    document.addEventListener('focusout', trapFocusHandlers.focusout),
    document.addEventListener('focusin', trapFocusHandlers.focusin),
    elementToFocus.focus();
}
function removeTrapFocus$1(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin),
    document.removeEventListener('focusout', trapFocusHandlers.focusout),
    document.removeEventListener('keydown', trapFocusHandlers.keydown),
    elementToFocus && elementToFocus.focus();
}
function focusVisiblePolyfill$1() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null,
    mouseClick = null;
  window.addEventListener('keydown', (event) => {
    navKeys.includes(event.code.toUpperCase()) && (mouseClick = !1);
  }),
    window.addEventListener('mousedown', (event) => {
      mouseClick = !0;
    }),
    window.addEventListener(
      'focus',
      () => {
        currentFocusedElement && currentFocusedElement.classList.remove('focused'),
          !mouseClick &&
            ((currentFocusedElement = document.activeElement), currentFocusedElement.classList.add('focused'));
      },
      !0
    );
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  }),
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    }),
    document.querySelectorAll('video').forEach((video) => video.pause()),
    document.querySelectorAll('product-model').forEach((model) => {
      model.modelViewerUI && model.modelViewerUI.pause();
    });
}
function onKeyUpEscape$1(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open'), summaryElement.setAttribute('aria-expanded', !1), summaryElement.focus();
}
function emit$1(type, detail) {
  let event = new CustomEvent(type, { bubbles: !0, cancelable: !0, detail });
  return document.dispatchEvent(event);
}
const __vite_glob_0_0 = Object.freeze(
  Object.defineProperty(
    {
      __proto__: null,
      emit: emit$1,
      fetchConfig,
      trapFocusHandlers,
      trapFocus: trapFocus$1,
      removeTrapFocus: removeTrapFocus$1,
      debounce,
      focusVisiblePolyfill: focusVisiblePolyfill$1,
      pauseAllMedia,
      onKeyUpEscape: onKeyUpEscape$1,
    },
    Symbol.toStringTag,
    { value: 'Module' }
  )
);
const utils = Object.assign({ './utils/index.js': __vite_glob_0_0 }),
  { emit, trapFocus, removeTrapFocus, focusVisiblePolyfill, onKeyUpEscape } = utils['./utils/index.js'];
Date.prototype.addDays = function (days) {
  const date = new Date(this.valueOf());
  return date.setDate(date.getDate() + days), date;
};
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button'),
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open')),
    summary.nextElementSibling.getAttribute('id') &&
      summary.setAttribute('aria-controls', summary.nextElementSibling.id),
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      const headerSection=document.getElementById("shopify-section-header");headerSection&&headerSection.classList.toggle("is-active");
    }),
    !summary.closest('header-drawer') && summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
try {
  document.querySelector(':focus-visible');
} catch {
  focusVisiblePolyfill();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input')),
      (this.changeEvent = new Event('change', { bubbles: !0 })),
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onButtonClick.bind(this))
      );
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown(),
      previousValue !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('quantity-input', QuantityInput);
typeof window.Shopify > 'u' && (window.Shopify = {});
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) return (selector.selectedIndex = i), i;
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, !1)
    : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options.method || 'post',
    params = options.parameters || {},
    form = document.createElement('form');
  form.setAttribute('method', method), form.setAttribute('action', path);
  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden'),
      hiddenField.setAttribute('name', key),
      hiddenField.setAttribute('value', params[key]),
      form.appendChild(hiddenField);
  }
  document.body.appendChild(form), form.submit(), document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  (this.countryEl = document.getElementById(country_domid)),
    (this.provinceEl = document.getElementById(province_domid)),
    (this.provinceContainer = document.getElementById(options.hideElement || province_domid)),
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this)),
    this.initCountry(),
    this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value), this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    value && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, value);
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex],
      raw = opt.getAttribute('data-provinces'),
      provinces = JSON.parse(raw);
    if ((this.clearOptions(this.provinceEl), provinces && provinces.length == 0))
      this.provinceContainer.style.display = 'none';
    else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        (opt.value = provinces[i][0]), (opt.innerHTML = provinces[i][1]), this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },
  clearOptions: function (selector) {
    for (; selector.firstChild; ) selector.removeChild(selector.firstChild);
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      (opt.value = values[i]), (opt.innerHTML = values[i]), selector.appendChild(opt);
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super(),
      (this.mainDetailsToggle = this.querySelector('details')),
      navigator.platform === 'iPhone' &&
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`),
      this.addEventListener('keyup', this.onKeyUp.bind(this)),
      this.addEventListener('focusout', this.onFocusOut.bind(this)),
      this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    ),
      this.querySelectorAll('button').forEach((button) =>
        button.addEventListener('click', this.onCloseButtonClick.bind(this))
      );
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    !openDetailsElement ||
      (openDetailsElement === this.mainDetailsToggle
        ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
        : this.closeSubmenu(openDetailsElement));
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget,
      detailsElement = summaryElement.parentNode,
      parentMenuElement = detailsElement.closest('.has-submenu'),
      isOpen = detailsElement.hasAttribute('open'),
      reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button')),
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    detailsElement === this.mainDetailsToggle
      ? (isOpen && event.preventDefault(),
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement))
      : setTimeout(() => {
          detailsElement.classList.add('menu-opening'),
            summaryElement.setAttribute('aria-expanded', !0),
            parentMenuElement && parentMenuElement.classList.add('submenu-open'),
            !reducedMotion || reducedMotion.matches
              ? addTrapFocus()
              : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }),
      summaryElement.setAttribute('aria-expanded', !0),
      trapFocus(this.mainDetailsToggle, summaryElement),
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus = !1) {
    event !== void 0 &&
      (this.mainDetailsToggle.classList.remove('menu-opening'),
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open'), details.classList.remove('menu-opening');
      }),
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      }),
      document.body.classList.remove('overflow-hidden'),
      removeTrapFocus(elementToFocus),
      this.closeAnimation(this.mainDetailsToggle));
  }
  onFocusOut(event) {
    setTimeout(() => {
      this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open'),
      detailsElement.classList.remove('menu-opening'),
      detailsElement.querySelector('summary').setAttribute('aria-expanded', !1),
      removeTrapFocus(detailsElement.querySelector('summary')),
      this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      animationStart === void 0 && (animationStart = time),
        time - animationStart < 500
          ? window.requestAnimationFrame(handleAnimation)
          : (detailsElement.removeAttribute('open'),
            detailsElement.closest('details[open]') &&
              trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary')));
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);
class HeaderDrawer extends MenuDrawer {
  constructor() {
    super(),
      (this.customHeader = document.querySelector('header-custom')),
      (this.headerIsTransparent = this.customHeader.classList.contains('is-transparent')),
      this.querySelector("#HeaderDrawer-Overlay").addEventListener("click", e => this.closeMenuDrawer(e)), this.querySelector("#close-menu-button").addEventListener("click", e => this.closeMenuDrawer(e)),
      this.querySelector("#HeaderDrawer-Content").addEventListener("click", e => {
          if (!e.target.closest('header-menu') || !e.target.closest('li')) {
              this.closeMenuDrawer(e);
          }
      });
  }
  openMenuDrawer(summaryElement) {
    var _a;
    (this.header = this.header || document.getElementById('shopify-section-header')),
      this.header.classList.add('menu-open'),
      this.customHeader &&
        this.headerIsTransparent &&
        ((_a = this.customHeader.querySelector('#Header')) == null || _a.classList.remove('header-transparent')),
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      }),
      summaryElement.setAttribute('aria-expanded', !0),
      trapFocus(this.mainDetailsToggle, summaryElement),
      document.body.classList.add('overflow-hidden');
  }
  closeMenuDrawer(event, elementToFocus) {
    var _a;
    super.closeMenuDrawer(event, elementToFocus),
      this.header.classList.remove('menu-open'),
      this.customHeader &&
        this.headerIsTransparent &&
        ((_a = this.customHeader.querySelector('#Header')) == null || _a.classList.add('header-transparent'));
  }
}
customElements.define('header-drawer', HeaderDrawer);
class VariantSelects extends HTMLElement {
  constructor() {
    super();

    let mediaGallery = document.querySelector("[id^='MediaGallery-']");
    if (mediaGallery) {
      this.currentValue = mediaGallery.getAttribute("data-current-option") || "";
    }
    this.addEventListener("change", this.onVariantChange.bind(this))
  }
  onVariantChange(e) {
    const oldValue = this.currentValue;
    let newOption = "";
    let newValue = "";

    // Check for customer type
    if (e.target.hasAttribute('data-customer-type')) {
        const customerType = e.target.getAttribute('data-customer-type');
        if (customerType === 'is_b2b_customer') {
            const selectedOption = e.target.options[e.target.selectedIndex];
            newOption = selectedOption.dataset.option || "";
            newValue = selectedOption.dataset.value || "";
            this.currentValue = newValue;
        } else if (customerType === 'is_b2c_customer') {
            newOption = e.target.dataset.option || "";
            newValue = e.target.dataset.value || "";
            this.currentValue = newValue; 
        }
    }

    // For Free Gift Promo
    const freeProductButtons = document.querySelectorAll('.FreeProductButton');
    if (freeProductButtons.length > 0) {
      freeProductButtons.forEach(button => {
        button.setAttribute('data-test-2', newOption);
      });
    }
    // For Free Gift Promo

    const upsell_container = document.querySelector('.upsell_container');
    // if(newValue==="Single"||newValue==="Double"){let a=document.querySelectorAll('addons-quantity select');a.forEach((b)=>{b.value='0';});}
    // if(upsell_container){if(newValue === "Northern Red Oak" || newValue === "Golden Oak"){upsell_container.classList.add("hidden");}else{upsell_container.classList.remove("hidden");}}
    
    // Reset all add-on quantities for any variant change
    const addonsSelects = document.querySelectorAll('addons-quantity select[name="quantity"]');
    addonsSelects.forEach((select) => {
      if (select.value !== '0') {
        select.value = '0';
        console.log("Resetting add-on quantity");
        // Trigger the change event to update pricing
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Handle specific variant hiding logic
    // const upsell_container = document.querySelector('.upsell_container');
    if(upsell_container){
      if(newValue === "Northern Red Oak" || newValue === "Golden Oak"){
        upsell_container.classList.add("hidden");
      } else {
        upsell_container.classList.remove("hidden");
      }
    }
    
    this.updateOptions(),
      this.updateMasterId(),
      this.currentVariant &&
        (emit('variant:swatch', { option: newOption, value: newValue }),
        this.updateMedia(newOption),
        this.updateURL(),
        this.updateVariantInput(),
        this.renderProductInfo(),
        this.updateCylindo(e),
        this.product_slider(newOption, oldValue));

    // For Free Gift Promo
    function updateCartInput(combinedValue) {
        console.info("Combined value:", combinedValue);
        
        const hiddenInput = document.querySelector(`input[name="hidden_variant_for_free_gift"][data-let-title="${combinedValue}"]`);
        if (hiddenInput) {
            console.info("Found matching input value:", hiddenInput.value);
            
            const cartForm = document.querySelector('form[action="/cart/add"]');
            if (cartForm) {
                const cartInput = cartForm.querySelector('input[name="id"]');
                if (cartInput) {
                    cartInput.value = hiddenInput.value;
                }
            }
        }
    }

    const freeProductButtonChecked = document.querySelector('.FreeProductButton:checked');
    if (freeProductButtonChecked) {
        const combinedValue = (freeProductButtonChecked.getAttribute('data-test-2') + '-' + 
            freeProductButtonChecked.getAttribute('data-kg-name'))
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
        
        updateCartInput(combinedValue);
    }
    else {
        const combinedValue = (newOption + '-benchbundle')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '');
        
        updateCartInput(combinedValue);
    }
    // For Free Gift Promo
  }

  product_slider(newOption, oldValue){
    const handleizedNewOption = newOption.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    const handleizedOldValue = oldValue.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');

    const old_items = document.querySelectorAll(`.ProductSwiper ul li[data-variant-option="${handleizedOldValue}"]`);
    old_items.forEach(olditem => {
        olditem.classList.remove('swiper-slide', 'swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
    });

    const new_items = document.querySelectorAll(`.ProductSwiper ul li[data-variant-option="${handleizedNewOption}"]`);
    new_items.forEach(newitem => {
        newitem.classList.add('swiper-slide');
        newitem.classList.remove('hidden');
    });

    productSlider.destroy(true, true);
    productSlider = new Swiper('.ProductSwiper', {
        pagination: {
            el: '.swiper-pagination',
        },
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }
  updateCylindo(e) {
    const cylindoSku = e.target.dataset.cylindoSku;
    cylindoSku && emit('variant:change', { sku: cylindoSku });
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) => !variant.options.map((option, index) => this.options[index] === option).includes(!1)
    );
  }
  updateMedia(option) {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    document.querySelector(`#MediaGallery-${this.dataset.section}`).updateGallery(this.currentVariant, option);
  }
  updateURL() {
    !this.currentVariant ||
      this.dataset.updateUrl === 'false' ||
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    !shareButton ||
      !shareButton.updateUrl ||
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    document
      .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
      .forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        (input.value = this.currentVariant.id), input.dispatchEvent(new Event('change', { bubbles: !0 }));
        
        // LOGIC TO DISPLAY CORRECT VIDEOS IN THUMBNAILS

        /* [data-variant-video] is an array not initially displayed 
        on page load, */
        const videoEls = document.querySelectorAll('[data-variant-video]');
        
        /* [data-variant-first-video] is rendered if on initial page load
        a video matches with the variants in alt text */
        const firstVideoEl = document.querySelectorAll('[data-variant-first-video]');
        
        // select first video and hide it on all subsequent updates 
        firstVideoEl && firstVideoEl.forEach((el) => {
          el.classList.add('hidden');
        })
        
        
        videoEls.forEach((el) => {
          el.classList.add('hidden');
          
          /* on every variant input change, hide all videos and show
          only the video matching with current variant */
          if (this.currentVariant.title === el.dataset.variantVideo) {
            el.classList.toggle('hidden')
          }
        })
      });
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    !pickUpAvailability ||
      (this.currentVariant && this.currentVariant.available
        ? pickUpAvailability.fetchAvailability(this.currentVariant.id)
        : (pickUpAvailability.removeAttribute('available'), (pickUpAvailability.innerHTML = '')));
  }
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    productForm && productForm.handleErrorMessage();
  }
  renderProductInfo() {
    this.setLoadingAnimation('variant-title'),
      this.setLoadingAnimation('price'),
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
          this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
        }`
      )
        .then((response) => response.text())
        .then((responseText) => {
          this.updateDom('price', responseText),
            this.updateDom('stock-availability', responseText),
            this.updateDom('sets-left', responseText),
            this.updateDom('variant-title', this.formatVariantTitle(responseText)),
            this.updateDom('shipping-estimator', responseText),
            this.updateDom('Shipping-Alert', responseText),
            this.updateDom('CostPerUnit', responseText),
            this.updateDom("imageModal", responseText),
            this.updateDom('StellaSavings', responseText),
            this.updateDom('financing-text', responseText),
            this.updateDom('current_variant_metafields', responseText),
            this.updateDom('financing-shop-pay', responseText),
            emit('update:affirm', { data: responseText });
        });
  }
  setLoadingAnimation(element) {
    const destination = document.querySelector(`#${element}-${this.dataset.section}`);
    destination && destination.firstElementChild.classList.toggle('loading');
  }
  updateDom(element, responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html'),
      destination = document.querySelector(`#${element}-${this.dataset.section}`),
      source = html.querySelector(
        `#${element}-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
      );
    source &&
      destination &&
      ((destination.innerHTML = source.innerHTML),
      [...source.attributes].forEach(attr => destination.setAttribute(attr.name, attr.value)));
  }
  toggleAddButton(disable = !0, text, modifyClass = !0) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]'),
      addButtonText = productForm.querySelector('[name="add"] > span');
    !addButton ||
      (disable
        ? (addButton.setAttribute('disabled', 'disabled'), text && (addButtonText.textContent = text))
        : (addButton.removeAttribute('disabled'), (addButtonText.textContent = window.variantStrings.addToCart)));
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`),
      addButton = button.querySelector('[name="add"]'),
      addButtonText = button.querySelector('[name="add"] > span'),
      price = document.getElementById(`price-${this.dataset.section}`);
    !addButton ||
      ((addButtonText.textContent = window.variantStrings.unavailable),
      price && price.classList.add('visibility-hidden'));
  }
  getVariantData() {
    return (
      (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)),
      this.variantData
    );
  }
  formatVariantTitle(text) {
      const isB2BCustomer = document.querySelector('[data-customer-type="is_b2b_customer"]') !== null;
      if (isB2BCustomer) {
          return text.replace(/(Retail Collect \/ |Retail DropShip \/ |Trade Professionals \/ )/g, '');
      }
      return text;
  }
}
customElements.define('variant-selects', VariantSelects);
class VariantSwatch extends VariantSelects {
  constructor() {
    super();
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(
      (fieldset) => Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    );
  }
}
customElements.define('variant-swatch', VariantSwatch);
class SliderComponent extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.slider = this.querySelector('[id^="Slider-"]')),
      (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')),
      (this.enableSliderLooping = !1),
      (this.currentPageElement = this.querySelector('.slider-counter--current')),
      (this.pageTotalElement = this.querySelector('.slider-counter--total')),
      (this.prevButton = this.querySelector('button[name="previous"]')),
      (this.nextButton = this.querySelector('button[name="next"]')),
      !this.slider || !this.nextButton)
    )
      return;
    this.initPages(),
      new ResizeObserver((entries) => this.initPages()).observe(this.slider),
      this.slider.addEventListener('scroll', this.update.bind(this)),
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this)),
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }
  initPages() {
    (this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0)),
      !(this.sliderItemsToShow.length < 2) &&
        ((this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft),
        (this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        )),
        (this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1),
        this.totalPages - 1 > 0 &&
          (this.prevButton.classList.remove('hidden'), this.nextButton.classList.remove('hidden')),
        this.update());
  }
  resetPages() {
    (this.sliderItems = this.querySelectorAll('[id^="Slide-"]')), this.initPages();
  }
  update() {
    const previousPage = this.currentPage;
    (this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1),
      this.currentPageElement &&
        this.pageTotalElement &&
        ((this.currentPageElement.textContent = this.currentPage),
        (this.pageTotalElement.textContent = this.totalPages)),
      this.currentPage != previousPage &&
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: { currentPage: this.currentPage, currentElement: this.sliderItemsToShow[this.currentPage - 1] },
          })
        ),
      !this.enableSliderLooping &&
        (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0
          ? this.prevButton.setAttribute('disabled', 'disabled')
          : this.prevButton.removeAttribute('disabled'),
        this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
          ? this.nextButton.setAttribute('disabled', 'disabled')
          : this.nextButton.removeAttribute('disabled'));
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    (this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset),
      this.slider.scrollTo({ left: this.slideScrollPosition });
  }
}
customElements.define('slider-component', SliderComponent);
class SwiperSlider extends HTMLElement {
  constructor() {
    var _a, _b, _c;
    super();
    const { css } = window.modules.swiper,
      sectionId = this.dataset.section;
    (this.sliderId = `#Swiper-${sectionId}`),
      (this.slider = this.querySelector(this.sliderId)),
      (this.materials = this.querySelectorAll('.product-material')),
      (this.colors = this.querySelectorAll('.product-color')),
      (this.tabs = this.querySelectorAll('.swiper-tab')),
      (this.products = this.querySelectorAll('.swiper-product')),
      (this.tabsWrapper = this.querySelector('.swiper-tabs')),
      (this.range = this.querySelector('.stepper-range-slider')),
      (this.jsImport = !1),
      (this.swiperOptions = {
        spaceBetween: 30,
        navigation: { nextEl: `#Swiper-Next-${sectionId}`, prevEl: `#Swiper-Prev-${sectionId}` },
        pagination: { el: `#Swiper-Pagination-${sectionId}`, clickable: !0 },
      }),
      this.cssInit(css),
      this.sliderInit(),
      (_a = this.tabs) != null &&
        _a.length &&
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', (e) => {
            const { index } = e.target.dataset;
            index && this.updateActiveSlide(index);
          });
        }),
      (_b = this.products) != null &&
        _b.length &&
        this.products.forEach((product) => {
          product.addEventListener('click', (e) => {
            const { index } = e.target.dataset;
            index && this.updateActiveSlide(index);
          });
        }),
      (_c = this.colors) != null &&
        _c.length &&
        this.colors.forEach((color) => {
          color.addEventListener('click', (e) => {
            const { index } = e.target.dataset;
            this.updateActiveElement(index, '.swiper-tab'),
              this.updateActiveElement(index, '.product-color'),
              this.updateActiveSlide(index);
          });
        }),
      this.range &&
        this.range.addEventListener('change', (e) => {
          const { value } = e.target;
          this.updateActiveSlide(parseInt(value) + 1);
        });
  }
  cssInit(css) {
    if (document.querySelector('#swiper-css')) return;
    const link = document.createElement('link');
    (link.id = 'swiper-css'), (link.rel = 'stylesheet'), (link.href = css), document.head.appendChild(link);
  }
  sliderInit() {
    const options = { rootMargin: '50px', threshold: 0.01 };
    new IntersectionObserver(this.loadSwiper.bind(this), options).observe(this);
  }
  loadSwiper(entries) {
    const { js } = window.modules.swiper;
    entries.forEach((entry) => {
      entry.isIntersecting &&
        !this.jsImport &&
        __vitePreload(() => import(js), [])
          .then((module) => module)
          .then(({ Swiper }) => {
            (this.jsImport = !0), this.swiperInit(Swiper);
          });
    });
  }
  swiperInit(Swiper) {
    (this.swiper = new Swiper(this.sliderId, this.swiperOptions)),
      this.swiper.on('slideChange', (e) => {
        this.onSlideUpdate(e);
      });
  }
  onSlideUpdate(e) {
    var _a, _b, _c, _d;
    const index = e.activeIndex + 1;
    (_a = this.tabs) != null && _a.length && this.updateActiveElement(index, '.swiper-tab'),
      (_b = this.products) != null && _b.length && this.updateActiveElement(index, '.swiper-product'),
      (_c = this.colors) != null && _c.length && this.updateActiveElement(index, '.product-color'),
      (_d = this.materials) != null && _d.length && this.updateActiveElement(index, '.product-material'),
      this.tabsWrapper && this.tabScrollToActive(index),
      this.range && (this.range.value = index - 1);
  }
  tabScrollToActive(index) {
    const tab = this.tabsWrapper.querySelector(`[data-index="${index}"]`),
      tabWidth = tab.offsetWidth,
      tabOffset = tab.offsetLeft,
      tabCenter = tabWidth / 2,
      tabCenterOffset = tabOffset + tabCenter,
      tabsWrapperCenter = this.tabsWrapper.offsetWidth / 2,
      scrollPosition = tabCenterOffset - tabsWrapperCenter;
    this.tabsWrapper.scrollTo({ left: scrollPosition, behavior: 'smooth' });
  }
  updateActiveElement(index, selector) {
    const oldElement = this.querySelector(`${selector}[aria-current="true"]`),
      newElement = this.querySelector(`${selector}[data-index="${index}"]`);
    (oldElement == null ? void 0 : oldElement.dataset.index) !==
      (newElement == null ? void 0 : newElement.dataset.index) &&
      (oldElement.removeAttribute('aria-current'), newElement.setAttribute('aria-current', !0));
  }
  updateActiveSlide(index) {
    var _a;
    (_a = this.swiper) == null || _a.slideTo(index - 1);
  }
}
customElements.define('swiper-slider', SwiperSlider);
class HeaderCustom extends HTMLElement {
  constructor() {
    super(), this.checkStickiness();
  }
  checkStickiness() {
    const stickyElm = document.querySelector('header');
    new IntersectionObserver(([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), {
      threshold: [1],
    }).observe(stickyElm);
  }
}
customElements.define('header-custom', HeaderCustom);



// Hide Zendesk widget
document.addEventListener('DOMContentLoaded', function() {
  try {
    if (window['zE'] && typeof window['zE'] === 'function') {
      window['zE']('messenger', 'hide');
    }
    
    const element = document.getElementById('launcher');
    if (element && element.tagName.toLowerCase() === 'iframe') {
      element.style.display = 'none';
    }
  } catch (error) {
    console.error('Error hiding Zendesk widget:', error);
  }
});
